import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow harmless "ResizeObserver loop" warnings (recharts) that trigger CRA's dev overlay.
const roError = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(roError)) {
    e.stopImmediatePropagation();
  }
});
// Wrap ResizeObserver callbacks in rAF to prevent the loop notification error entirely.
const _RO = window.ResizeObserver;
if (_RO) {
  window.ResizeObserver = class extends _RO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => cb(entries, observer));
      });
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
